export const RESET_DATA_PANEL = 'reset_datapanel';

export function resetDataPanel() {
  return {
    type: RESET_DATA_PANEL,
  };
}
